<i class="wiz-icon- cell-group-icon" (click)="expand()">{{myIcon}}</i>



